import { BoxSize } from "../../Types";

export default {
  handleActiveObjectModification,
  handleActiveObjectMovement,
  handleObjectPosition,
  handleObjectCoordinatesOnResize,
};

/**
 * @method handleActiveObjectModification
 * @param e {fabric.IEvent} Event of moving an object in canvas
 * @returns void
 * @description Event for handling object modification.
 */
function handleActiveObjectModification(e: fabric.IEvent) {
  handleObjectScale(e);
  // handleObjectPosition(e);
}

/**
 * @method handleActiveObjectMovement
 * @param e {fabric.IEvent} Event of moving an object in canvas
 * @returns void
 * @description Event for handling object movements.
 */
function handleActiveObjectMovement(e: fabric.IEvent): void {
  // handleObjectPosition(e);
}

/**
 * @method handleObjectPosition
 * @param e {fabric.IEvent} Event of moving an object in canvas
 * @returns void
 * @description Method used to prevent moving object in canvas outside the frame.
 */
export function handleObjectPosition(e: fabric.IEvent): void {
  const { left, top, canvas } = e.target;
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  let leftOffset = left;
  let topOffset = top;

  if (left > canvasWidth) {
    leftOffset = canvasWidth;
  }

  if (left < 0) {
    leftOffset = 0;
  }

  if (top > canvasHeight) {
    topOffset = canvasHeight;
  }
  if (top < 0) {
    topOffset = 0;
  }

  e.target.set({
    left: leftOffset,
    top: topOffset,
  });
}

/**
 * @method handleObjectScale
 * @param e {fabric.IEvent} Event of moving an object in canvas
 * @returns void
 * @description Method used to handle object scaling.
 */
export function handleObjectScale(e: fabric.IEvent): void {
  const { width, height, canvas, scaleX, scaleY } = e.target;

  const canvasWidth = canvas.getWidth();
  const objectWidthScaleToCanvas = canvasWidth / width;
  const canvasHeight = canvas.getHeight();
  const objectHeightScaleToCanvas = canvasHeight / height;

  if (objectWidthScaleToCanvas < scaleX) {
    e.target.scaleToWidth(width * objectWidthScaleToCanvas);
  }
  if (objectHeightScaleToCanvas < scaleY) {
    e.target.scaleToWidth(height * objectHeightScaleToCanvas);
  }
}

/**
 * @method handleObjectCoordinatesOnResize
 * @param canvas {fabricCanvasInstance} Fabric instance that is to be edited
 * @param scaledCanvasSize
 * @param action
 */
function handleObjectCoordinatesOnResize(
  canvas: fabric.Canvas,
  scaledCanvasSize: BoxSize,
  action: "grow" | "shrink",
  offset?: { left: number; top: number }
) {
  let left = (canvas.getWidth() - scaledCanvasSize.width) / 2;
  let top = (canvas.getHeight() - scaledCanvasSize.height) / 2;

  canvas.getObjects().forEach(function(object) {
    if (object.type !== "line") {
      let tempLeft = left + object.left;
      let tempTop = top + object.top;
      if (action === "shrink") {
        tempLeft = object.left - offset.left;
        tempTop = object.top - offset.top;
      }
      object.set({
        left: tempLeft,
        top: tempTop,
      });
      object.setCoords();
    }
  });
  canvas.renderAll();
}
